const installations = [
    { 
        id: 0,
        location: 'Velammal Hospitals, Chennai, Tamil Nadu',
    },
    { 
        id: 1,
        location:'Accura Speciality Lab, Chennai, Tamil Nadu'
    },
    { 
        id: 2,
        location:'Vanavil Scans, Chennai, Tamil Nadu'
    },
    { 
        id: 3,
        location:'Apollo Hospitals, Chennai, Tamil Nadu'
    },
    { 
        id: 4,
        location:'ES hospital, Villupuram, Tamil Nadu'
    },
    { 
        id: 5,
        location:'Subha Anandham Hospital, Cuddalore, Tamil Nadu'
    },
    { 
        id: 6,
        location:'Mahatma Gandhi Medical College, Pondicherry, Tamil Nadu'
    },
    { 
        id: 7,
        location:'G. Kuppuswamy Naidu Memorial Hospital, Coimbatore, Tamil Nadu'
    },
    { 
        id: 8,
        location:'KG Hospital Coimbatore, Tamil Nadu'
    },
    { 
        id: 9,
        location:'GKNM Hospital, Coimbatore, Tamil Nadu'
    },
    { 
        id: 10,
        location:'PSG Hospital, Coimbatore, Tamil Nadu'
    },
    { 
        id: 11,
        location:'Erode Cancer Centre, Erode, Tamil Nadu'
    },
    { 
        id: 12,
        location:'Soorya Multispeciality Hospital, Thiruchengode, Tamil Nadu'
    },
    { 
        id: 13,
        location:'Meenakshi Mission Hospital and Research Centre, Madurai, Tamil Nadu'
    },
    { 
        id: 14,
        location:'KSDC Hospital, Tanjore, Tamil Nadu'
    },
    { 
        id: 15,
        location:'Jeeva Centenary Trust, Tanjore, Tamil Nadu'
    },
    { 
        id: 16,
        location:'Annal Gandhi Memorial Hospital, Trichy, Tamil Nadu'
    }
];

export default installations;